import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@fluentui/react-components';

import { useActionButtonStyles } from '../styles/tiles-grid-cell-action-button-style';

const ActionButton = ({
  text, icon: Icon, onClick, primary, className,
}) => {
  const classes = useActionButtonStyles();
  const appearance = primary ? 'primary' : 'secondary';
  return (
    <Button
      icon={<Icon />}
      onClick={onClick}
      className={classnames('cell-button', classes.actionButton, className)}
      appearance={appearance}
    >
      {text}
    </Button>
  );
};

ActionButton.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  onClick: PropTypes.func.isRequired,
  primary: PropTypes.bool,
  // injected
  className: PropTypes.string.isRequired,
};

ActionButton.defaultProps = {
  primary: true,
};

export const TilesGridCellActionButton = ActionButton;
